export default __webpack_public_path__ + "soundcloud.svg";